export const searchFormOption = function () {
  return [
    {
      prop: "orgId",
      label: "所属机构",
      type: "cascader",
      placeholder: "请选择所属机构",
      propConfig: {
        children: "children",
        label: "orgName",
        value: "id",
        checkStrictly: true,
        emitPath: false,
      },
      options: this.orgOption,
    },
    // {
    //   prop: "date",
    //   label: "延期日期",
    //   type: "range-date",
    // },
    {
      prop: "keywords",
      label: "关键字",
      type: "input",
      placeholder: "请输入内保单号、车牌号",
    },
  ];
};

export default {};
